import { Component } from '@angular/core';
import { PagePanelComponent } from '../page-panel/page-panel.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { AppstateService } from 'src/app/services/appstate.service';

@Component({
  selector: 'app-element-panel',
  templateUrl: './element-panel.component.html',
  styleUrl: './element-panel.component.scss'
})
export class ElementPanelComponent extends PagePanelComponent {

  constructor(public appStateService: AppstateService,
              public navigationService: NavigationService) {
    super(appStateService, navigationService);
    this.showBackButton = false;
    this.showDetailsButton = false;
    this.showSidepanelButton = false;
  }

}
